/* REACT IMPORTS */
import { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

/* STYLES */
import "../styles/global.css";

/* LAYOUT */
import Layout from "../layout";

/* PAGES */
import AuthLogin from "../pages/auth/login";

import Dashboard from "../pages/dashboard";

import Leads from "../pages/dashboard/leads";

/* SERVICES */
import Services from "../pages/dashboard/services";
import AddService from "../pages/dashboard/services/add-service";
import EditService from "../pages/dashboard/services/edit-service";

/* BLOGS */
import Blogs from "../pages/dashboard/blogs";
import AddBlog from "../pages/dashboard/blogs/add-blog";
import EditBlog from "../pages/dashboard/blogs/edit-blog";

import SiteSettings from "../pages/dashboard/site-settings";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AuthLogin />} />

          {/* DASHBOARD */}
          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />

          {/* LEADS */}
          <Route
            path="/contact-requests"
            element={
              <Layout>
                <Leads
                  key="contact"
                  formType="contact"
                  title="Contact Requests"
                  description="Enquiries submitted from the contact forms on the website."
                />
              </Layout>
            }
          />
          <Route
            path="/refill-requests"
            element={
              <Layout>
                <Leads
                  key="refill"
                  formType="refill"
                  title="Refill Requests"
                  description="Prescription refill requests submitted from the website."
                />
              </Layout>
            }
          />
          <Route
            path="/transfer-requests"
            element={
              <Layout>
                <Leads
                  key="transfer"
                  formType="transfer"
                  title="Transfer Requests"
                  description="Prescription transfer requests submitted from the website."
                />
              </Layout>
            }
          />
          <Route
            path="/auto-rx-requests"
            element={
              <Layout>
                <Leads
                  key="auto-refill"
                  formType="auto-refill"
                  title="Auto Rx Enrollments"
                  description="Automatic refill enrollments submitted from the website."
                />
              </Layout>
            }
          />

          {/* SERVICES */}
          <Route
            path="/services"
            element={
              <Layout>
                <Services />
              </Layout>
            }
          />
          <Route
            path="/services/add"
            element={
              <Layout>
                <AddService />
              </Layout>
            }
          />
          <Route
            path="/services/edit/:id"
            element={
              <Layout>
                <EditService />
              </Layout>
            }
          />

          {/* HEALTH BLOGS */}
          <Route
            path="/blogs"
            element={
              <Layout>
                <Blogs />
              </Layout>
            }
          />
          <Route
            path="/blogs/add"
            element={
              <Layout>
                <AddBlog />
              </Layout>
            }
          />
          <Route
            path="/blogs/edit/:id"
            element={
              <Layout>
                <EditBlog />
              </Layout>
            }
          />

          {/* SITE SETTINGS */}
          <Route
            path="/site-settings"
            element={
              <Layout>
                <SiteSettings />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
